<template>
	<div class="select-modal">
		<avatar :image="image" :width="140" :isTeam="isTeam" :clickable="false"></avatar>

		<div class="name">{{ name }}</div>

		<link-list-item title="コインを贈る" icon="coin" @click="onCoinPresentClick"></link-list-item>
		<link-list-item :title="title" :icon="icon" @click="onListSeeClick"></link-list-item>

		<b-button rounded type="is-info" @click="onCancelClick">キャンセル</b-button>
	</div>
</template>

<script>
import Avatar from '@/components/Avatar'
import LinkListItem from '@/components/LinkListItem'

export default {
	name: 'SelectModal',
	components: {
		Avatar,
		LinkListItem,
	},
	props: {
		name: {
			type: String,
			default: '',
		},
		image: {
			type: String,
			default: '',
		},
		staffId: {
			type: String,
			default: '',
		},
		teamId: {
			type: String,
			default: '',
		},
		isTeam: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	computed: {
		title: function() {
			return !this.isTeam ? 'メンバー紹介を見る' : 'チーム紹介を見る';
		},
		icon: function() {
			return !this.isTeam ? 'user' : 'team';
		},
	},
	methods: {
		onListSeeClick: function() {
			this.close();
			if (this.isTeam) {
				this.$router.push({ name: 'team', params: { teamId: this.teamId }});
			} else {
				this.$router.push({ name: 'staff', params: { staffId: this.staffId, token: this.$consts.DUMMY_TOKEN }});
			}

		},
		onCoinPresentClick: function() {
			this.close();
			if (this.isTeam) {
				this.$router.push({ name: 'coin-present-to-team', params: { teamId: this.teamId }});
			} else {
				this.$router.push({ name: 'coin-present-to-staff', params: { staffId: this.staffId }});
			}
			
		},
		onCancelClick: function() {
			this.close();
		},
		close: function() {
			this.$store.commit('closeSelectModal');
		},
	},
}
</script>

<style lang="scss">

</style>
